module.exports = __webpack_public_path__ + "img/myntra-seeklogo.com.4efd5b70.svg";